import { SimpleForm, SimpleFormProps, TextInput, required, BooleanInput, ArrayInput, SimpleFormIterator, email, Toolbar, SaveButton } from 'react-admin';


function FormToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton disabled={props.pristine || props.validating} />
    </Toolbar>
  );
}

export default function MessageSubjectsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm 
      {...props} 
      redirect="list"
      toolbar={<FormToolbar />}
    >
      <TextInput
        fullWidth
        autoComplete="off"
        label="Nome"
        source="name"
        validate={[required()]}
      />

      <ArrayInput
        source="recipients"
        label="Destinatários"
        validate={[required()]}
      >
        <SimpleFormIterator>
          <TextInput label="Nome" source="name" validate={[required()]} />
          <TextInput
            label="E-mail"
            source="email"
            type="email"
            validate={[required(), email()]}
          />
        </SimpleFormIterator>
      </ArrayInput>

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
